var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-input__site-btn-wrapper"},[_c('ProfileBtn',{attrs:{"image-url":_vm.link.image,"img-class":{ [_vm.imgClass]: true }}},[_vm._v("\n    "+_vm._s(_vm.link.label)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }